import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import React, {
  Dispatch,
  Fragment,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { useRecoilValue } from 'recoil';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../../hooks/session';
import { schoolListState } from '../../common/atom';
import {
  educationOffices,
  getSchoolClassCount,
  getSchoolGradeCount,
  getSchoolInSchoolGroup,
  schoolGroups,
} from '../../common/helper';
import buttonOption from '../../images/sub/Button_option.svg';

const DEFAULT_WIDTH = '8rem';
interface Props {
  title: string;
  // onDownload: () => void;
}

export const SwTitleDownloadMore: React.FC<Props> = ({ title }) => {
  const navigate = useNavigate();
  const { loginVal } = useSession();
  const schoolList = useRecoilValue(schoolListState);
  const [schools, setSchools] = useState<any[]>([]);
  const [educationOfficeSeq, setEducationOfficeSeq] = useState<number>(0);
  const [schoolClassSeq, setSchoolClassSeq] = useState<number>(0);
  const [schoolGroupSeq, setSchoolGroupSeq] = useState<number>(1);
  const [schoolSeq, setSchoolSeq] = useState<number>(0);
  const [schoolGrade, setSchoolGrade] = useState<number>(1);
  const [schoolClass, setSchoolClass] = useState<string>('1');
  const [tabValue, setTabValue] = useState<number>(0);

  return (
    <Box
      className=''
      sx={{
        mt: '.5rem',
        mb: '.5rem',
        borderBottom: 1,
        borderColor: 'divider',
        backgroundColor: '#fff',
      }}
    >
      <Typography className='title'>{title}</Typography>
    </Box>
  );
};
